/**
 * Escapes a single CSV field per RFC 4180: quoted (with internal quotes doubled) whenever
 * the value contains a comma, quote, or newline — otherwise left bare.
 */
const escapeCsvField = (value: string): string => (/["\r\n,]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value);

export const toCsv = (rows: string[][]): string => rows.map((row) => row.map(escapeCsvField).join(",")).join("\r\n");

/** Triggers a browser download of `content` as a file named `filename`. */
export const downloadCsv = (filename: string, content: string): void => {
    const url = URL.createObjectURL(new Blob([content], { type: "text/csv;charset=utf-8;" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};

/**
 * Builds a CSV from `headers` + `rows` and downloads it as `<filenamePrefix>-<today>.csv`.
 * The one-call entry point every export button should use — `toCsv`/`downloadCsv` are
 * exported separately mainly so tests can drive them individually.
 */
export const exportCsv = (filenamePrefix: string, headers: string[], rows: string[][]): void => {
    const today = new Date().toISOString().slice(0, 10);
    downloadCsv(
        `${filenamePrefix}-${today}.csv`,
        toCsv([
            headers,
            ...rows,
        ]),
    );
};
